import { isEqual } from "lodash";

/**
 * Filter table header object by removing items with empty text and returning
 * an array of objects instead of an object
 * @param headers
 * @returns {{text: *, value: string, visible: (*|boolean), sortable: (*|boolean), order: null}[]}
 */
export const filterHeaders = function(headers) {
  return headers.filter(header => header.text && header.text.length > 0)
    .sort((a, b) => {
      return (a.order === null) - (b.order === null)
        || +(a.order > b.order) || -(a.order < b.order);
    });
};

export const loadFromLocalStorage = function(key, defaults = []) {
  const storedItems = JSON.parse(localStorage.getItem(key)) || [];
  return loadHeaders(storedItems, defaults);
};

export const loadHeaders = function(storedItems = [], defaults = []) {
  const filteredDefaults = filterHeaders(defaults);
  // if new default items are added/removed, should retrieve new defaults instead
  const hasHeadersChanges = !hasEqualHeaders(filteredDefaults, storedItems);
  return hasHeadersChanges ? filteredDefaults : filterHeaders(storedItems);
};

function hasEqualHeaders(defaults, stored) {
  const defaultsHeaders = defaults.map(header => header.text).sort();
  const storedHeaders = stored.map(header => header.text).sort();
  return isEqual(defaultsHeaders, storedHeaders);
}
